export const TimeRenderer = ({value} = {}) => {
  return value
}
